import { render } from "./ItemDropdown.vue?vue&type=template&id=6f239d7c"
import script from "./ItemDropdown.vue?vue&type=script&lang=js"
export * from "./ItemDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__